<template>
  <b-nav-item-dropdown
    v-if="userData.fullname"
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{ userData.fullName || userData.username }}
        </p>
        <span class="user-status">{{ userData.role }}</span>
      </div>
      <b-avatar
        size="40"
        :src="userData.avatar"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      >
        <feather-icon v-if="!userData.fullName" icon="UserIcon" size="22" />
      </b-avatar>
    </template>

    <b-dropdown-item
      :to="{ name: 'pages-profile' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="UserIcon" class="mr-50" />
      <span>Profile</span>
    </b-dropdown-item>
    <b-dropdown-item
      :to="{ name: 'apps-email' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="MailIcon" class="mr-50" />
      <span>Inbox</span>
    </b-dropdown-item>
    <b-dropdown-item
      :to="{ name: 'apps-todo' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="CheckSquareIcon" class="mr-50" />
      <span>Task</span>
    </b-dropdown-item>
    <b-dropdown-item
      :to="{ name: 'apps-chat' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="MessageSquareIcon" class="mr-50" />
      <span>Chat</span>
    </b-dropdown-item>

    <b-dropdown-divider />

    <b-dropdown-item
      :to="{ name: 'pages-account-setting' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="SettingsIcon" class="mr-50" />
      <span>Settings</span>
    </b-dropdown-item>
    <b-dropdown-item
      :to="{ name: 'pages-pricing' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="CreditCardIcon" class="mr-50" />
      <span>Pricing</span>
    </b-dropdown-item>
    <b-dropdown-item
      :to="{ name: 'pages-faq' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="HelpCircleIcon" class="mr-50" />
      <span>FAQ</span>
    </b-dropdown-item>
    <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
      <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
      <span>Logout</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { initialAbility } from "@/libs/acl/config";
// import useJwt from "@/auth/jwt/useJwt";
import { avatarText } from "@core/utils/filter";
// import { getNewAuthRoute } from '@/auth/utils';
// import { getDomain } from '@/utils/getDomain';
// import { AccessTokenKey, AUTH_STATE_COOKIE } from '@/store/auth/auth.store.constants';
export default {
  components: {
  },
  data() {
    return {
      // userData: JSON.parse(localStorage.getItem("userData")),
      avatarText,
    };
  },
  computed: {
    currentCommunity() {
      return this.$store.getters.currentCollective;
    },
    mainCommunity() {
      return this.$store.getters.mainCollective;
    },
    mainSpace() {
      return this.mainCommunity.key ? this.mainCommunity : this.currentCommunity;
      // return this.currentCollective?.parentKey ? this.mainCollective : this.currentCollective;
    },
    isNexos() {
      return process.env.VUE_APP_CUSTOMER === 'nexos' || this.mainSpace?.key === 'f3166db0-b635-11ef-805d-f79ce25412de';
    },
    userData () {
      return JSON.parse(localStorage.getItem("userData")) || {}
    },
  },
  methods: {
    async logout() {
      try {
        // Reset ability first
        this.$ability.update(initialAbility);
        
        // Use the Vuex store's logout action which handles all cookie/storage cleanup
        await this.$store.dispatch('logout');
      } catch (error) {
        console.error('Error during logout:', error);
        // Fallback to basic logout if something goes wrong
        window.location.href = process.env.VUE_APP_MY_NECTIOS_URL;
      }
    },
  },
};
</script>
